export const createBackup = (payload?: any) => ({
    type: "@saga/CREATE_BACKUP",
    payload
});

